<template>
    <div class="navbar-item vue-ready__hide"
            :class="stateFacet"
            @click="onClick"
            @mouseenter="onHover"
            @mouseleave="onLeave">
        <button class="u-reset navbar-item--link navbar-item--link__button"
                v-if="hasChildren"
                slot="label"
        >
            {{ label }}
        </button>

        <a class="u-reset navbar-item--link"
                v-else
                slot="label"
                :target="linkTarget"
                :href="path"
        >
            {{ label }}
        </a>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem/index';
    import { mapActions, mapState } from 'vuex';
    import { mq } from 'util/dom/mq';

    export default {
        mixins: [bemMixin('navbar-item')],

        props: {
            label: {
                type: String,
                required: true,
            },

            path: {
                type: String,
                required: true,
            },

            show_all_label: {
                type: String,
                default: null,
            },


            preview_link_label: {
                type: String,
                default: null,
            },

            is_active: {
                type: Boolean,
                default: false,
            },

            is_redirect: {
                type: Boolean,
                default: false,
            },

            has_active_children: {
                type: Boolean,
                default: false,
            },

            description: {
                type: String,
                default: null,
            },

            image: {
                type: Object,
                default: null,
            },

            /** @type {INavigationEntry[]} */
            items: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                isClickTriggered: false,
            };
        },

        computed: {
            ...mapState('navigation', ['isPreviewVisible']),

            linkTarget() {
                return this.is_redirect ? '_blank' : '_self';
            },

            stateFacet() {
                const isActive = this.has_active_children || this.is_active;
                return [
                    this.bemAdd(isActive ? 'active' : null),
                    this.bemAdd(this.is_redirect ? 'extern' : null),
                ];
            },

            itemsWithOverviewLink() {
                if (!this.items || this.items.length === 0) {
                    return null;
                }

                if (mq('<=lg')) {
                    return [{ path: this.path, label: this.show_all_label }, ...this.items];
                }

                return this.items;
            },

            hasChildren() {
                return this.items && this.items.length > 0;
            },
        },

        methods: {
            ...mapActions('navigation', ['setPreviewLinks', 'setPreviewContent', 'setPreviewVisibility', 'setAnchorPosition']),
            onLeave() {
                if (!this.isClickTriggered) {
                    this.closePreview();
                }
            },

            onHover() {
                this.openPreview();
            },

            onClick() {
                if (this.isClickTriggered) {
                    this.closePreview();
                    return;
                }

                this.isClickTriggered = true;
                this.openPreview();
            },

            closePreview() {
                this.setPreviewVisibility({ isVisible: false });
            },

            openPreview() {
                if (!this.items || !this.items.length) {
                    return;
                }

                this.setPreviewLinks({ links: this.itemsWithOverviewLink });
                this.setPreviewVisibility({ isVisible: true });

                const { left, top, height } = this.$el.getBoundingClientRect();

                this.setAnchorPosition({
                    x: left,
                    y: top + height,
                });

                if (this.description) {
                    this.setPreviewContent({
                        component: 'dyn-nav-content-preview',
                        props: {
                            title: this.label,
                            description: this.description,
                            image: this.image,
                            link: { path: this.path, label: this.preview_link_label },
                        },
                    });
                } else {
                    this.setPreviewContent({
                        component: null,
                        props: null,
                    });
                }
            },
        },


        watch: {
            isPreviewVisible(val) {
                if (val === false) {
                    this.isClickTriggered = false;
                }
            },
        },
    };
</script>
